import { Cell } from '../../../../components/ReusableComponents/Table'
import styles from './HotelIdCell.module.scss'

const HotelIdCell = ({ displayId, ...props }) => (
  <Cell className={styles.idCell} {...props} noHoverStyle>
    #{displayId}
  </Cell>
)

export default HotelIdCell
